import axios from 'axios';
import { UntypedFormGroup, UntypedFormControl, Validators, FormControl } from '@angular/forms';
import { Authenticationservice } from './../../services/authentication.service';
import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/storage';
import Swal from 'sweetalert2';
import { map, startWith } from 'rxjs/operators';
declare var $: any;

@Component({
  selector: 'app-askformoney67',
  templateUrl: './askformoney67.component.html',
  styleUrls: ['./askformoney67.component.css']
})
export class Askformoney67Component implements OnInit, OnDestroy, AfterViewInit {
  userdata: any;
  t0: any;
  usercode;
  askformoney: UntypedFormGroup;
  FormForwardFN: UntypedFormGroup;
  uploadPercentage$: Observable<number>;
  valuesTomodal = [];
  isLoading = false;

  e_comment1 = new UntypedFormControl(null, Validators.required);
  e_money_amt = new UntypedFormControl(null, Validators.required);
  e_docid = new UntypedFormControl(null, Validators.required);

  //@ViewChild('moneydata', { static: false }) moneydataTable: any;
  @ViewChild('moneydata') moneydataTable: ElementRef;
  constructor(
    private auth: Authenticationservice,
    private spinner: NgxSpinnerService,
    private storage: AngularFireStorage) {
    this.userdata = this.auth.Authention();
    this.supzone[0] = this.userdata.zonedata;
    let supcode = this.userdata.supcode;

    this.askformoney = new UntypedFormGroup({
      fmcode: new UntypedFormControl(''),
      t0: new UntypedFormControl(''),
      subtype: new UntypedFormControl(0),
      //  date_type0: new FormControl(''), 
    });

    if (supcode == '919' || supcode == '928') {
      this.setEdit = true;
    }
    else this.setEdit = false;
  }
  setEdit = false;
  supzone = ['', ''];

  ngOnInit(): void {
    this.getfinancebyzone();
    this.goloadfarmerinzone();
    this.loadtype_money();
  }
  tab_s = 1;

  clearFm() {
    this.fmcode = [];
    //this.oneplant = [];
    this.dataonefarmer = [];

    this.cleartext();
  }
  year = ['2425', '6768', '67/68', '2567/2568']

  sum_money_amt = 0 //วงเงินที่ใช้ไป
  sum_money_amt1 = 0 //ขอเกี้ยว
  sum_money_amt2 = 0 //ขอเบิกปัจจัย
  sum_if_amt2 = 0 //เผื่อเบิกปัจจัย


  RSUM_long = 0 //หนี้คงค้างของปี
  credit = 0 //มีวงเงิน
  limit = 0 //คงเหลือ


  ck_money_amt_last: any[];
  ck_realty_debt: any[];

  ck_money_amt_fm(fmcode: string) {
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[fnc_ck_money_amt_fm6768]('${fmcode}')&w=1=1`;
    this.spinner.show();
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      console.log('ck_money_amt_fm:', data);
      if (data.length > 0) {
        this.ck_money_amt_last = data;
        this.sum_money_amt1 = data[0].sum_money_amt1;
        this.sum_money_amt2 = data[0].sum_money_amt2;
        this.sum_money_amt = data[0].sum_money_amt;
        this.sum_if_amt2 = data[0].if_amt2;

        this.ck_realty_debt = data;
        this.RSUM_long = data[0].RSUM_long + this.debt_TKS;
        this.credit = (data[0].guaranter + data[0].sumRealty);
        setTimeout(() => {
          if (this.credit > 0 || this.RSUM_long > 0)
            this.limit = (this.credit) - (data[0].sum_money_amt + data[0].RSUM_long)
        }, 100);
      } else {
        this.ck_realty_debt = [];
        this.RSUM_long = 0;
        this.credit = 0;
        this.limit = 0;

        this.sum_money_amt = 0;
        this.sum_money_amt1 = 0;
        this.sum_money_amt2 = 0;
      }

    }).catch(err => { throw (err); })
  }

  datatype_m: any[]
  subtype0: any[]
  loadtype_money() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*,left([id],1)[l_id],RIGHT([id],1)[r_id]&f=[CPS6263].[dbo].[type_money]&w=left(id,1)in('a','b','c','d')";
    axios.get(url)
      .then(res => {
        this.datatype_m = res.data;
        this.subtype0 = this.datatype_m.filter((el: any) => el.r_id == '0');
        //console.log('famerlist',this.famerlist)
      }).catch(err => { throw (err); })
  }

  // เลือกประเภทย่อย
  fsub = null
  sc_docA = null

  subtype1: any
  subtypeSL: string
  SubTypeSelectM(type0: string) {
    this.subtype1 = this.datatype_m.filter((el: any) => el.l_id == type0 && el.r_id != '0');
    //this.askformoney.get['subtype'].setValue(0);
    //this.askformoney.get("comment").value;
    this.fsub = null
  }
  SubTypeSelectS(sc_id: string, sc_doc: string) {
    this.sc_docA = sc_doc
    this.subtypeSL = sc_id
  }

  // โหลดข้อมูลชาวไร่ 

  famerlist = [];

  goloadfarmerinzone() {
    this.spinner.show();
    let dataU = this.userdata;
    let sub = '';

    // แก้ไขพิเศษ
    if (this.setEdit == true) { sub = 'all' }
    // ผจก โซน
    else if (dataU.userlevel == 14) { sub = dataU.zonedata.substring(0, 2) }
    // ผจก ส่วน
    else if (dataU.userlevel == 15) { sub = dataU.zonedata.substring(0, 2) }

    //let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_fmcodeIn_cp${this.year[1]}?sub=` + this.userdata.zonedata;
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[fnc_fmcodeIn_cp${this.year[1]}]('${sub}')&w=1=1`
    //console.log('url:', url);
    axios.get(url)
      .then(res => {
        this.spinner.hide();
        let data = res.data;
        this.famerlist = data;
        this.famerlist2 = data;
        //console.log('famerlist:', date)
      }).catch(err => { throw (err); })
  }

  famerlist2 = [];
  search_dataFM() {//กรองข้อความ
    let keyword = (this.txtFindIn.trim()).toLowerCase();
    if (keyword == '') { this.famerlist = this.famerlist2; }
    else {
      this.famerlist = this.famerlist2.filter((el) => ((el.fmcode_b1.indexOf(keyword) > -1) || (el.fmname.indexOf(keyword) > -1))) || [];
      //if (this.famerlist.length! > 0) this.famerlist = []
    }
  }

  // ข้อมูลแปลงของชาวไร่ 1 คน
  dataonefarmer = [];
  canget: any;
  ckfarmer = true;

  @ViewChild('farmertable', { static: false }) farmerTable: any;

  sum_arae = 0;
  lastPL = 0;
  debt_TKS = 0;
  can_withdraw = false
  fmcode: any = {};
  txtFindIn = '';
  goloaddata() {
    let fmcode = this.fmcode//((<HTMLInputElement>document.getElementById("codefm")).value).slice(0, 10)
    console.log('fmcode:', fmcode);
    this.LoadCreditamt(fmcode.fmcode_b1);
    //this.oneplant = []
    if ((fmcode.fmcode_b1.length) == 0) { alert('ลองกรอกรหัสชาวไร่ใหม่ หรือ คลิ๊กเลือก') }
    else {
      //this.fmcode = fmcode;      
      let sel_fm = fmcode//this.famerlist.filter((el: any) => el.fmcode_b1 == fmcode)[0];
      this.supzone[1] = sel_fm.SUPZONE;
      console.log('ckfamer', sel_fm, this.supzone);
      //console.log('ckfamer.length' ,ckfamer.length);
      this.lastPL = sel_fm.lastPercentLoan;
      this.debt_TKS = sel_fm.debt_TKS;
      //console.log('fmcode', fmcode);
      if (sel_fm == 0) { alert('ชาวไร่ไม่ได้อยู่ในโซน/ส่วนที่รับผิดชอบ') }
      else if (sel_fm.PromiseIN == 0 || sel_fm.approve == 'N') {
        alert("ไม่สามารถเบิกได้ค่ะ");
        this.ckfarmer = true;
        this.can_withdraw = false;
        this.spinner.hide();
      }
      else if (sel_fm.zoneban == 'Y') {
        alert("ไม่สามารถทำรายการได้ เนื่องจากเป็นชาวไร่สำหรับฝ่ายกฎหมาย");
        this.ckfarmer = true;
        this.spinner.hide();
      }
      /*else if (sel_fm[0].approve == 'Y' && sel_fm[0].lastPercentLoan == 0) {
        alert("ไม่สามารถเบิกเงินได้ เนื่องจากเป็นชาวไร่ เกรด 3");
        this.ckfarmer = true;
        this.spinner.hide();
      }*/
      else {
        this.ckfarmer = false;
        this.spinner.hide();
      }
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_cp" + this.year[1] + "_basic_a]&w=fmcode='" + sel_fm.fmcode_b1 + "'";
      this.dataonefarmer = [];
      this.spinner.show();
      axios.get(url).then(res => {
        this.spinner.hide();
        let data = res.data;
        if (data.length > 0) {
          this.dataonefarmer = (data).sort((a, b) => { return (a.intlandno) - (b.intlandno) });

          data.forEach(item => {
            this.sum_arae += item.landvalue;
          });
          console.log('sum_arae:', this.sum_arae)
          console.log('sum_if_amt2:', this.sum_if_amt2)
          console.log('sum_arae*sum_if_amt2:', this.sum_arae * this.sum_if_amt2)

          //this.dataonefarmer
          /*setTimeout(() => {
            this.farmerTable.nativeElement.DataTable();
          }, 800);*/
          /*
          this.ck_sum_money_amt(sel_fm.fmcode_b1);
          this.lodadck_realty_debt(sel_fm.fmcode_b1);
          */
          this.ck_money_amt_fm(sel_fm.fmcode_b1);
          this.loadfactor_fm(sel_fm.fmcode_b1);
        }
      }).catch(err => { throw (err); })
    }
  }

  crdamt = [];
  LoadCreditamt(fmcode: any) {
    this.spinner.show();
    let url2 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[cps6263].[dbo].[v_sum_money_amt]&w=[YearID]='" + this.year[1] + "'and[fmcode]='" + fmcode + "'";
    this.canget = null;
    axios.get(url2).then(res => {
      this.spinner.hide();
      if (res.data.length > 0) {
        this.crdamt = res.data;
      }
      else {
        this.crdamt = []
      }
    }).catch(err => { console.log(err); })
  }

  filteredList = [];
  filterList(query: string) {
    this.filteredList = this.famerlist.filter(item =>
      item.fmname.includes(query) || item.fmcode_b1.includes(query)
    );
  }

  forwardcredit: any;
  checkcredit: any;
  sel_landno = {};

  snaponedata(sdata: any, sty = 1) {
    let data = sdata//this.dataonefarmer.filter(el => el.itid == itid);
    let data2 = this.crdamt.filter(el => el.itid == data.itid);

    console.log('itid:', sdata)
    this.form_money.itid = data.itid;
    this.form_money.intlandno = data.intlandno;
    this.sel_landno = data;
    this.form_money.typeD = sty;
    if (sty == 1) {
      $("#plantnum").val(data.intlandno + ', ประเภทอ้อย: ' + data.CaneTypeName + ', พื้นที่: ' + data.landvalue.toLocaleString() + ' ไร่');
      //this.form_money.docid = data.docid;
    }
    else if (sty == 2) {
      $("#plantnum").val(data.intlandno + ', ประเภทอ้อย: ' + data.canename + ', พื้นที่: ' + data.landvalue.toLocaleString() + ' ไร่');
      this.form_money.firebaseid = data.firebaseid;
      this.form_money.docid = data.docid;
      this.form_money.comment = data.comment_fm;
      this.form_money.count = data.money_amt;

    }
    console.log('crdamt', this.crdamt, ', sel_landno', this.sel_landno);

    this.form_money.fmcode = data.fmcode;
    if (data2.length == 0 || data2 == null) {
      this.checkcredit = [{ 'cdam': parseInt(data.credit_amount), 'sma': 0 }];
    }
    else {
      this.checkcredit = [{ 'cdam': parseInt(data.credit_amount), 'sma': parseInt(data2[0].sum_money_amt) }];
    }

    //document.getElementById("fmnamelable").innerHTML = data.fmname;
    //$("#fmnamelable").val(data.fmname)
    // $("#fmname").val(data[0].fmname);
    console.log('form_money', this.form_money);

  }

  form_money = { firebaseid: '', docid: '', itid: '', intlandno: '', fmcode: '', comment: '', count: 0, typeD: 0 };
  // บันทึกข้อมูล
  gosave(d = 1) {
    let fmcode = this.form_money.fmcode;
    let cmdcheck = parseInt(this.checkcredit[0].cdam) - parseInt(this.checkcredit[0].sma);
    let itid = this.form_money.itid;
    let intlandno = this.form_money.intlandno;
    let comemnt = this.form_money.comment//this.askformoney.get("comment").value;
    let conut = this.form_money.count//this.askformoney.get("count").value;
    let type_m = this.subtypeSL
    let firebaseid = this.form_money.firebaseid

    let over_limit = "0";
    let doc_status = "0";
    let supzoneS = '';
    if (this.setEdit) supzoneS = this.supzone[1];
    else supzoneS = this.supzone[0];


    //console.log('fmcode',fmcode,'cmdcheck',cmdcheck,'conut',conut,'type_m',type_m,'substring type_m',type_m.substring(1,1),'conut',conut ,'cmdcheck',cmdcheck)
    //let type_money:string = null
    // กรณีเกินวงเงินแปลงนั้นๆ

    // สำหรับการขอจาก ผจก.ที่เกินวงเงิน
    // if (conut > this.checkcredit.cdam) { over_limit = "1" }
    // { alert("จำนวนเงินเกินวงเงิน กรุณาลองใหม่");}
    //  if ( conut  > cmdcheck && this.userdata.userlevel != '15') {
    //     alert("จำนวนเงินเกินวงเงิน กรุณาลองใหม่");
    //   }

    console.log('conut :', conut, ' | cmdcheck:', cmdcheck)
    console.log('checkcredit', this.checkcredit)

    if (this.can_withdraw = false) { alert("ไม่สามารถบันทึกข้อมูลได้"); }
    else if (fmcode == null || fmcode == '') { alert("กรุณาระบุชาวไร่"); }
    else if (type_m == null || type_m == '') { alert("กรุณาเลือกประเภทเกี้ยว"); }
    else if (comemnt == null || comemnt == '') { alert("กรุณาระบุคำอธิบาย"); }
    else if (conut <= 0 || conut == null || conut == 0) { alert("กรุณาระบุจำนวนเงินที่มากกว่า 0"); }
    else if (type_m.substring(0, 1) == 'a' && conut > cmdcheck) { alert("เงินส่งเสริมระยะสั้น ไม่สามารถเกินวงเงินรายแปลงได้"); }
    else if (conut > this.limit) { alert("ไม่สามารถบันทึกข้อมูลได้ เนื่องจากเบิกเกินหลักทรัพย์ค้ำประกัน"); }
    else {
      let textconfirm = `ยืนยันการบันทึก ${comemnt} จำนวนเงิน ${conut.toLocaleString()} บาท`;
      if (type_m.substring(0, 1) != 'a' && conut > cmdcheck) { over_limit = "1"; doc_status = "2" }
      //if (conut > this.limit) { textconfirm = "เนื่องจากยอดรวม " + conut + " เกินวงเงินคงเหลือ " + this.limit + " ต้องการการบันทึกข้อมูล" }
      if (confirm(textconfirm)) {
        let url = ''
        if (d == 1) {
          url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/insert_getfactorw?YearID='${this.year[1]}'&supcode='${this.userdata.supcode}'
            &Zone_ID='${supzoneS}'&factor_type='1'&itid='${itid}'&intlandno='${intlandno}'&fmcode='${fmcode}'&comment1='${comemnt}'&money_amt=${conut}
            &img_url='${this.geturlcontact}'&over_limit='${over_limit}'&doc_status='${doc_status}'&type_money='${type_m}'`;

        }
        else if (d == 2) {
          url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?firebaseid=${firebaseid}&doc_status='${doc_status}'
          ,over_limit='${over_limit}',money_amt=${conut},comment1='${comemnt}',type_money='${type_m}'`
        }
        url = url.replace(/\n\s*/g, '\n');
        axios.post(url).then(res => {
          if (res.data.rowsAffected[0] >= 1) {
            alert("บันทึกข้อมูลเรียบร้อยแล้วค่ะ");
            //this.askformoney.reset();
            this.geturlcontact = '';
            this.LoadCreditamt(fmcode);
            /*
            this.ck_sum_money_amt(fmcode);
            this.loadfactor_fm(fmcode);
            */
            this.ck_money_amt_fm(fmcode);

            setTimeout(() => {
              this.getfinancebyzone();
            }, 100);
            this.cleartext();
          }
          else { alert("!!!! บันทึกข้อมูลไม่สำเร็จ !!!!"); }
        }).catch(err => { throw (err); })
      }
      else {
        {
          /*alert(" !! ยกเลิกบันทึกข้อมูลเรียบร้อยแล้วค่ะ !!");
          this.askformoney.reset();*/
        }
      }
    }
  }

  geturlcontact: string;
  // upload fire ภาพ
  onFileUpload(files: FileList): void {
    console.log(files);
    const file = files[0]; // get single file
    const path = `brr_smartfarm/contract/photo/${this.userdata.supcode}/` + this.year[1] + `/${file.name}`;
    const ref = this.storage.ref(path);
    const task = this.storage.upload(path, file);
    this.uploadPercentage$ = this.storage
      .upload(path, file)
      .percentageChanges();
    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          ref
            .getDownloadURL()
            .toPromise()
            .then((url) => {
              // const photo: Photo = { url };
              // console.log(url);
              // this.urlimg = = url;

              // this.firestore.collection('photos').doc(this.truckq).set(photo);
            });
        })
      )
      .subscribe();

    let bucket = 'brr-farmluck.appspot.com'
    let url_pubilc = 'https://storage.googleapis.com/' + bucket + '/brr_smartfarm/contract/photo/' + this.userdata.supcode + '/' + this.year[1] + '/' + file.name;
    console.log(url_pubilc);
    this.geturlcontact = url_pubilc;
  }

  // clear ช่อง
  cleartext() {
    //$("input").val('');
    //$("input:text").val('');
    //$("input:number").val('');
    this.geturlcontact = '';
    //this.dataonefarmer = []
    this.sel_landno = {};
    this.form_money = { firebaseid: '', docid: '', itid: '', intlandno: '', fmcode: '', comment: '', count: 0, typeD: 0 };
    $("#plantnum").val('');

  }

  // โหลดข้อมูลสินเชื่อ
  datafinance = [];
  newtable: any
  getfinancebyzone() {
    if (this.newtable != undefined || this.newtable != null) {
      this.newtable.destroy();
    }
    this.isLoading = true;
    let supzoneA = this.userdata.zonedata;
    let dtop = '';

    let url2 = ''
    // console.log('userdata zonedata:' ,this.userdata.zonedata);
    if (this.setEdit) {
      dtop = 'top 100 *';
      url2 = `&w=1=1 order by[docid]desc`;
    }
    else if (this.userdata.userlevel == 15) {
      dtop = '*';
      url2 = `&w=[partcode]='${supzoneA}'&[over_limit]=1`;
    }
    else {
      dtop = 'top 200 *';
      url2 = `&w=[zonePost]='${supzoneA}'`;
    }
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=${dtop}&f=[CPS6263].[dbo].[v_getfinance${this.year[1]}]${url2}`

    this.spinner.show;
    axios.get(url).then(res => {
      this.spinner.hide();
      if (res.data.length > 0) {
        this.datafinance = [];
        let data = res.data;
        setTimeout(() => {
          this.datafinance = data;
          this.isLoading = false;
          setTimeout(() => {
            this.newtable = $(this.moneydataTable.nativeElement).DataTable({ order: [[0, 'desc']] });
          }, 300);
        }, 400);
      } else {
        this.datafinance = [];
        this.isLoading = false;
      }
    }).catch(err => { throw (err) });
  }

  fm_factor = [];
  loadfactor_fm(fmcode: string) {
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance${this.year[1]}]&w=[fmcode]='${fmcode}'and[doc_status]='F'`;
    axios.get(url)
      .then(res => {
        this.fm_factor = res.data;

        //console.log('famerlist',this.famerlist)
      }).catch(err => { throw (err); })
  }


  ngOnDestroy() {
    this.forwardcredit = null;
    this.dataonefarmer = null;
    this.userdata = null;
    this.usercode = null;
    this.geturlcontact = null;
    this.datafinance = [];
  }

  // ส่งข้อมูลไปพิมพ์
  getfmcode(fmcode) {
    localStorage.setItem('fmcodedataforaskmoney', JSON.stringify(fmcode).toString());
  }

  // ต้องการยกเลิกรายการ
  cancledoc_id(data) {
    Swal.fire({
      title: 'ยืนยัน ยกเลิกเกี้ยว รายการนี้?',
      // text: 'You will not be able to recover this file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?firebaseid=" + data.firebaseid + "&doc_status='X'";
        //console.log('url-cancledoc_id:', url);
        axios.post(url).then(res => {
          if (res.data.rowsAffected == 1) {
            this.datafinance.filter(el => el.docid != data.docid);
            Swal.fire('ยกเลิกรายการเกี้ยวสำเร็จ!', '', 'success')
            setTimeout(() => {
              if (this.newtable != undefined || this.newtable != null) {
                this.newtable.destroy();
              }
              this.newtable = $(this.moneydataTable.nativeElement).DataTable({ order: [[0, 'desc']] });
            }, 300);
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'เกิดความผิดพลาดในการยกเลิกเกี้ยว!',
              footer: '<a href="">กรุณาลองใหม่อีกครั้ง หากยังพบปัญหา ให้ติดต่อ itBRD?</a>'
            })
          }
        })
      } else if (result.dismiss == Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการการทำรายการ',
          // 'Your imaginary file is safe :)',
          'cancle'
        )
      }
    })
  }

  // ส่งรายการให้ฝ่ายสินเชื่อ

  forwardtoFN(doc: any) {
    $("#forwardtofn").modal('show');
    this.valuesTomodal = [doc.docid, doc.money_amt, doc.comment1, doc.fmname, doc.datepost];
    // console.log('value to modal is ',this.valuesTomodal);
  };

  // บันทึกข้อมูลของ หัวหน้าส่วน ไปยังฝ่ายสินเชื่อ
  saveforwardtoFN(f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_getfactor?docid=" + f.e_docid
      + "&comment1=" + f.e_comment1 + "&money_amt=" + f.e_money_amt + "&doc_status=0";
    //console.log('url: ',url);
    Swal.fire({
      title: 'ยืนยันการบันทึกข้อมูล?',
      // text: 'You will not be able to recover this file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        axios.post(url).then(res => {
          if (res.data.rowsAffected == 1) {
            Swal.fire('Saved!', '', 'success')
            this.getfinancebyzone();
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'เกิดความผิดพลาดในการอัพเดตข้อมูล!',
              footer: '<a href="">กรุณาลองใหม่อีกครั้ง หากยังพบปัญหา ให้ติดต่อ itBRD?</a>'
            })
          }
        })
      } else if (result.dismiss == Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการบันทึกข้อมูล',
          // 'Your imaginary file is safe :)',
          'cancle'
        )
      }
    })
  };

  // ส่งรายการให้ฝ่ายสินเชื่อ
  forwardtoFNX(data) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?firebaseid=" + data.firebaseid + "&doc_status=0";
    if (confirm("ยืนยันส่งรายการไปยังฝ่ายสินเชื่อ ?") == true) {
      console.log('url-cancledoc_id:', url);
      axios.post(url)
        .then(res => {
          if (res.data.rowsAffected[0] == 1) { alert("ส่งรายการไปยังฝ่ายสินเชื่อแล้ว"); this.getfinancebyzone(); }
          else {
            alert("!!! เกิดข้อผิดพลาดในการส่งรายการไปยังฝ่ายสินเชื่อ กรุณาลองใหม่ !!!")
          }
        }).catch(err => { throw (err); })

    } else {
      return false;
    }
  };

  date2th(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit"//, hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

  ngAfterViewInit(): void {
    /*setTimeout(() => {
      $(this.moneydataTable.nativeElement).DataTable();
    }, 3500);*/
  }

  CommaFormatted(event) {
    // skip for arrow keys
    if (event.which >= 37 && event.which <= 40) return;
    // format number
    if (this.valuesTomodal) {
      this.valuesTomodal[1] = this.valuesTomodal[1].replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  };

  numberCheck(args) {
    if (args.key === 'e' || args.key === '+' || args.key === '-') {
      return false;
    } else {
      return true;
    }
  };
}
